import { useApiMutation } from "./use-api-mutation";
import useInvalidateTeamMembers from "./use-invalidate-team-members";

export default function useDeleteTeamMember(shopId: string, userId: string) {
	const invalidateTeamMembers = useInvalidateTeamMembers(shopId);

	return useApiMutation("delete", "/shops/{shopId}/members/{userId}", {
		invalidate: invalidateTeamMembers,
		mapVariables: async () => ({
			params: { path: { userId, shopId } },
		}),
	});
}
